import { Component, Inject, OnInit, ChangeDetectionStrategy, signal } from '@angular/core'
import { FieldTree, form } from '@angular/forms/signals'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

import { TuettuKieli } from '@lemon/core/model/common'

import { arvonMuutokset } from './_jaettu-angular/_lomakkeet/arvon-muutokset'
import { LemonTranslationService } from './_jaettu-angular/service/lemon-translation.service'

export interface VaihdaKieliDialogData {
  tallenna: boolean
}

@Component({
  selector: 'vaihda-kieli-dialog',
  templateUrl: './vaihda-kieli.dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class VaihdaKieliDialog implements OnInit {
  kieli: FieldTree<TuettuKieli>

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: VaihdaKieliDialogData,
    private translationService: LemonTranslationService,
    private dialogRef: MatDialogRef<VaihdaKieliDialog>,
  ) {
    this.kieli = form(signal<TuettuKieli>(this.translationService.nykyinenKieli))
    arvonMuutokset(this.kieli).subscribe(kieli => {
      this.translationService.vaihdaKieli(kieli)
      this.dialogRef.close()
    })
  }

  ngOnInit() {}
}
